{
  "familyId": "SPR-LEEN-ENGELS",
  "questions": [
    {
      "id": "SPR-LEEN-ENGELS-001",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft een verslag over mode. Welke spelling van het Engelse leenwoord is correct?",
      "context": "De leerling twijfelt over de spelling van een kledingstuk.",
      "options": ["jeans", "djiens", "jeens", "djienz"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse leenwoorden", "content": "Engelse leenwoorden behouden hun Engelse spelling. 'Jeans' is Engels: de 'j' klinkt als 'dzj', de 'ea' als 'ie', en de 's' blijft. Je schrijft het niet fonetisch in het Nederlands.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_jeans",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Jeans' is een Engels leenwoord dat zijn oorspronkelijke spelling behoudt. Regel: Engelse leenwoorden schrijf je in het Nederlands met de Engelse spelling, niet fonetisch. De Engelse 'j' klinkt als 'dzj' en de 'ea' klinkt als 'ie', maar je schrijft het niet zoals je het in het Nederlands zou spellen. Vergelijk met andere Engelse kledingwoorden: sweater, T-shirt, hoodie — allemaal met Engelse spelling. Controleer: ziet je geschreven woord er Engels of fonetisch-Nederlands uit? Lijkt het meer op hoe je het hoort dan op het Engelse origineel, dan is het bijna zeker fout.",
        "solutionSteps": ["Herken dat 'jeans' een Engels leenwoord is", "Regel: Engelse leenwoorden behouden hun oorspronkelijke spelling", "De Engelse 'j' = 'dzj'-klank, 'ea' = 'ie'-klank", "Dus: jeans (niet djiens, jeens of djienz)"],
        "distractorExplanations": {
          "0": "Correct! 'Jeans' behoudt de Engelse spelling. De 'j' klinkt als 'dzj' en de 'ea' als 'ie'.",
          "1": "Je schreef het woord fonetisch: 'djiens'. Maar de regel is: Engelse leenwoorden behouden hun oorspronkelijke spelling. De Engelse 'j' klinkt als 'dzj', maar je schrijft gewoon 'j'. Onthoud: Engelse spelling behouden, niet vernederlandsen.",
          "2": "Je schreef 'jeens' — je behield de Engelse 'j' maar veranderde 'ea' naar 'ee'. De regel is: het hele woord behoudt de Engelse spelling. 'Ea' is een Engelse lettercombinatie die je niet aanpast. Onthoud: het hele woord blijft Engels.",
          "3": "Je schreef het volledig fonetisch: 'djienz'. Maar Engelse leenwoorden behouden hun spelling: jeans. De 'j' blijft 'j', de 'ea' blijft 'ea', de 's' blijft 's'. Onthoud: schrijf het zoals het in het Engels staat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.loanword-phonetic-dutch", "label": "Volledig fonetisch vernederlandst", "optionIndex": 1 },
          { "id": "spr.loanword-partial-phonetic", "label": "Deels fonetisch (ea→ee)", "optionIndex": 2 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Volledig fonetisch vernederlandst", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-002",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Een redacteur controleert een tekst over architectuur. Welke zin bevat een fout bij een Engels leenwoord?",
      "context": "Controleer de Engelse leenwoorden in elke zin.",
      "options": [
        "Het design van het nieuwe stadion is spectaculair.",
        "De layout van de website is overzichtelijk.",
        "De manager presenteerde het nieuwe plan.",
        "Het desain van het nieuwe stadion is spectaculair."
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Design — Engelse spelling", "content": "Het woord 'design' is Engels en behoudt de Engelse spelling. De 'i' klinkt in het Engels als 'ai', maar je schrijft het niet als 'desain'. De combinatie '-sign' is typisch Engels (vergelijk: sign, signal, signature).", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_design",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De fout zit in 'desain' — het moet 'design' zijn. Regel: Engelse leenwoorden behouden hun oorspronkelijke Engelse spelling. De Engelse 'i' in 'design' klinkt als 'ai', maar je schrijft het niet fonetisch. De lettercombinatie '-sign' is typisch Engels — vergelijk: sign (teken), signal (signaal), signature (handtekening). De andere zinnen zijn correct: layout, manager. Controleer per leenwoord: schrijf je het zoals het in het Engels staat (-sign, -ight, -age) of fonetisch (-sain, -ait, -idzj)? Alleen de Engelse spelling is goed.",
        "solutionSteps": ["Controleer elk Engels leenwoord in de zinnen", "Herken 'desain' als fonetische Nederlandse spelling", "Het oorspronkelijke Engelse woord is 'design' (met -sign)", "De fout zit in de laatste zin: desain → design"],
        "distractorExplanations": {
          "0": "Deze zin is juist gespeld. 'Design' is de correcte Engelse spelling. De fout zit in de zin met 'desain'. Onthoud: de lettercombinatie '-sign' is typisch Engels.",
          "1": "Deze zin is juist gespeld. 'Layout' is correct — het is een Engels leenwoord dat in het Nederlands dezelfde spelling heeft. De fout zit in de zin met 'desain'.",
          "2": "Deze zin is juist gespeld. 'Manager' behoudt de Engelse spelling. De fout zit in de zin met 'desain' → 'design'.",
          "3": "Correct! 'Desain' is de fonetische Nederlandse spelling. De redacteur verbetert het naar 'design' — Engelse leenwoorden behouden hun oorspronkelijke spelling."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 0 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 1 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-003",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Een leerling maakt een presentatie over technologie en gebruikt deze Engelse leenwoorden. Welk woord heeft hij FOUT gespeld?",
      "context": "Controleer de spelling van elk Engels leenwoord.",
      "options": ["display", "science", "highlite", "item"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Highlight — Engelse spelling", "content": "Het woord 'highlight' is Engels en behoudt de Engelse spelling met '-ight'. De combinatie '-ight' is typisch Engels: light, night, right, sight, highlight. Je schrijft het niet als 'highlite' of 'hailait'.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_highlight",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Highlite' is fout — het moet 'highlight' zijn. Regel: Engelse leenwoorden behouden hun oorspronkelijke spelling. De Engelse lettercombinatie '-ight' is een vast patroon: light, night, right, sight, highlight. De 'gh' is stom (je hoort hem niet), maar je schrijft hem wel. De andere woorden (display, science, item) zijn correct gespeld. Controleer: zie je een Engelse vaste lettercombinatie ('-ight', '-sign', '-age')? Vervang die niet door iets fonetisch — de Engelse spelling is altijd de juiste.",
        "solutionSteps": ["Controleer elk woord op Engelse spelling", "Herken 'highlite' als fout: de '-ight' combinatie ontbreekt", "Correct: highlight (met -ight, zoals light, night, right)", "Display, science, item zijn correct"],
        "distractorExplanations": {
          "0": "'Display' is correct gespeld — het is een Engels leenwoord met de oorspronkelijke spelling. De fout zit in 'highlite'.",
          "1": "'Science' is correct gespeld — het is een Engels leenwoord. De 'sc' klinkt als 's', maar je behoudt de Engelse spelling. De fout zit in 'highlite'.",
          "2": "Goed gevonden! 'Highlite' moet 'highlight' zijn. Onthoud het -ight patroon: light, night, right, highlight.",
          "3": "'Item' is correct gespeld — het is een Engels leenwoord. De 'i' klinkt als 'ai' in het Engels, maar de spelling blijft 'item'. De fout zit in 'highlite'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 0 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 1 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Correct woord als fout gezien", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-004",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "true_false_series",
      "question": "Beoordeel of elk Engels leenwoord correct gespeld is.",
      "data": {
        "statements": [
          { "text": "'Highlight' is correct gespeld.", "isTrue": true },
          { "text": "'Desain' is correct gespeld.", "isTrue": false },
          { "text": "'Label' is correct gespeld.", "isTrue": true },
          { "text": "'Skedsjoel' is correct gespeld.", "isTrue": false },
          { "text": "'Computer' is correct gespeld.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Engelse leenwoorden", "content": "Engelse leenwoorden behouden hun oorspronkelijke Engelse spelling. 'Desain' moet 'design' zijn, 'skedsjoel' moet 'schedule' zijn. De andere woorden (highlight, label, computer) zijn correct.", "icon": "book" } }],
      "conceptId": "english_loanword_tf_series",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden behouden hun oorspronkelijke Engelse spelling. 'Highlight', 'label' en 'computer' zijn correct — dat is de Engelse spelling. 'Desain' is fout (moet 'design' zijn — de '-sign' combinatie is typisch Engels). 'Skedsjoel' is fout (moet 'schedule' zijn — de 'sch-' klinkt als 'sk' in het Engels). Controleer elk woord: ziet het er Engels uit of fonetisch-Nederlands? Lijkt het meer op de uitspraak dan op het Engelse origineel, dan is het bijna zeker fout gespeld.",
        "solutionSteps": [
          "Highlight: Engelse spelling met -ight → correct ✓",
          "Desain: fonetisch vernederlandst → fout (design)",
          "Label: Engelse spelling → correct ✓",
          "Skedsjoel: fonetisch vernederlandst → fout (schedule)",
          "Computer: Engelse spelling → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-005",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in deze tekst en verbeter het woord.",
      "data": {
        "text": "De trainer droeg een sweater en een nieuw paar djiens. Hij keek op zijn tablet naar het trainingsschema.",
        "errors": [
          {
            "word": "djiens",
            "position": 10,
            "correction": "jeans",
            "explanation": "'Djiens' is de fonetische Nederlandse spelling. Het Engelse leenwoord behoudt zijn oorspronkelijke spelling: jeans. De Engelse 'j' klinkt als 'dzj', maar je schrijft gewoon 'j'."
          }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Engelse leenwoorden in tekst", "content": "Engelse leenwoorden behouden hun oorspronkelijke spelling, ook in een Nederlandse tekst. 'Sweater', 'tablet' en 'trainingsschema' zijn correct. 'Djiens' moet 'jeans' zijn.", "icon": "book" } }],
      "conceptId": "english_loanword_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Djiens' is fonetisch vernederlandst — het moet 'jeans' zijn. Regel: Engelse leenwoorden behouden hun oorspronkelijke spelling. De andere Engelse woorden in de tekst (sweater, tablet) zijn correct gespeld. Handige tip bij foutenzoeken: lees elk woord en vraag jezelf af: 'Is dit de originele Engelse spelling, of een fonetische Nederlandse versie?' Als het er te Nederlands uitziet, is het waarschijnlijk fout.",
        "solutionSteps": [
          "Lees de tekst en zoek Engelse leenwoorden",
          "Sweater: correct Engelse spelling ✓",
          "Djiens: fonetisch vernederlandst → fout!",
          "Correctie: djiens → jeans (Engelse spelling behouden)",
          "Tablet: correct Engelse spelling ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-006",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "fill_in",
      "question": "Een journalist schrijft over eten. Vul het Engelse leenwoord correct in: 'We bestelden een medium ... in het restaurant.' (Het woord rijmt op 'break' en betekent een stuk vlees.)",
      "data": {
        "acceptedAnswers": ["steak"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "correctAnswer": "steak",
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Steak — Engelse spelling", "content": "'Steak' is een Engels leenwoord. De 'ea' klinkt als 'ee' (zoals in 'break'), maar je schrijft het niet als 'steek'. Engelse leenwoorden behouden hun oorspronkelijke spelling. Andere voorbeelden met 'ea': team, jeans, steak.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_steak_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Steak' is een Engels leenwoord dat zijn oorspronkelijke spelling behoudt. De Engelse 'ea' klinkt hier als 'ee' (net als in 'break' en 'great'), maar je schrijft het niet als 'steek'. Dit is een weetwoord: je moet de Engelse spelling uit je hoofd leren. Andere Engelse woorden met 'ea': team (ea = ie), jeans (ea = ie), steak (ea = ee). Let op: de 'ea' klinkt niet altijd hetzelfde in het Engels! Controleer: vul het woord in een zin in en vergelijk je spelling met andere Engelse woorden die je kent — als 'team' en 'break' allebei met 'ea' worden geschreven, dan 'steak' ook.",
        "solutionSteps": ["Het woord rijmt op 'break' en betekent een stuk vlees", "Het is een Engels leenwoord: steak", "Engelse spelling behouden: steak (niet steek)", "Onthoud: de Engelse 'ea' kan als 'ee' klinken (steak, break, great)"]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-007",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Een klasgenoot schrijft 'desain' en 'djiens' in zijn werkstuk. Je legt uit waarom dat fout is. Welke uitleg klopt?",
      "context": "Pas de spellingregel voor Engelse leenwoorden toe.",
      "options": [
        "Engelse leenwoorden schrijf je altijd zoals je ze hoort in het Nederlands (desain, djiens, hailait).",
        "Engelse leenwoorden behouden hun Engelse spelling, ook als de uitspraak anders is dan je verwacht (design, jeans, highlight).",
        "Engelse leenwoorden krijgen altijd een Nederlandse spelling als ze in het woordenboek staan.",
        "Engelse leenwoorden mag je zowel Engels als fonetisch Nederlands schrijven."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "De regel voor Engelse leenwoorden", "content": "Engelse leenwoorden behouden hun oorspronkelijke Engelse spelling. Je schrijft ze niet fonetisch in het Nederlands. Voorbeelden: design (niet desain), jeans (niet djiens), highlight (niet hailait), steak (niet steek).", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_rule",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De regel is helder: Engelse leenwoorden behouden hun Engelse spelling. Ook als de uitspraak anders is dan je op basis van Nederlandse spellingregels zou verwachten. 'Design' klinkt als 'desain', maar je schrijft 'design'. 'Jeans' klinkt als 'dzjiens', maar je schrijft 'jeans'. Dit is anders dan bij sommige Franse leenwoorden die wél een Nederlandse spellingvariant hebben gekregen. Onthoud de regel: Engelse spelling = de enige correcte optie. Controleer bij twijfel: schrijf het woord op zoals jij het zou doen, en vergelijk met een Engelse tekst of woordenboek — komt het exact overeen, dan klopt het.",
        "solutionSteps": ["Engelse leenwoorden behouden hun Engelse spelling", "Je schrijft ze NIET fonetisch in het Nederlands", "Voorbeelden: design, jeans, highlight, steak", "Dit moet je uit je hoofd leren — er is geen Nederlandse spellingregel voor"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je Engelse woorden schrijft zoals je ze hoort. Maar dat geldt niet voor Engelse leenwoorden — die behouden hun oorspronkelijke spelling. 'Desain' en 'djiens' zijn fonetische Nederlandse spellingen die niet correct zijn.",
          "1": "Correct! Engelse leenwoorden behouden hun Engelse spelling, ook als de uitspraak anders is dan je verwacht.",
          "2": "Je dacht waarschijnlijk dat Engelse woorden een Nederlandse spelling krijgen als ze in het woordenboek staan. Maar de meeste Engelse leenwoorden behouden hun Engelse spelling, ook in het Nederlandse woordenboek. Uitzonderingen zijn zeldzaam.",
          "3": "Je dacht waarschijnlijk dat beide spellingen mogen. Maar er is maar één correcte spelling: de Engelse. 'Design' is correct, 'desain' is fout. Er is geen keuze. Onthoud: Engelse spelling = de enige correcte optie."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.loanword-phonetic-dutch", "label": "Denkt dat fonetisch schrijven mag", "optionIndex": 0 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Denkt dat woordenboek vernederlandst", "optionIndex": 2 },
          { "id": "spr.loanword-phonetic-dutch", "label": "Denkt dat beide spellingen mogen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-ENGELS-008",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "matching",
      "question": "Koppel de foute spelling aan de correcte Engelse spelling.",
      "data": {
        "pairs": [
          { "left": "desain", "right": "design" },
          { "left": "highlite", "right": "highlight" },
          { "left": "laibel", "right": "label" },
          { "left": "skedsjoel", "right": "schedule" }
        ],
        "correctMatches": { "0": "0", "1": "1", "2": "2", "3": "3" }
      },
      "correctAnswer": { "0": "0", "1": "1", "2": "2", "3": "3" },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse spelling onthouden", "content": "Engelse leenwoorden behouden hun oorspronkelijke spelling:\n• design (niet desain) — de '-sign' combinatie\n• highlight (niet highlite) — de '-ight' combinatie\n• label (niet laibel) — de 'a' klinkt als 'ei'\n• schedule (niet skedsjoel) — de 'sch-' combinatie\n\nDeze woorden moet je uit je hoofd leren.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Engelse leenwoorden behouden hun oorspronkelijke spelling, ook als die heel anders is dan de Nederlandse uitspraak: 'desain' → design (de '-sign' combinatie), 'highlite' → highlight (de '-ight' combinatie), 'laibel' → label (de 'a' klinkt als 'ei' in het Engels), 'skedsjoel' → schedule (de 'sch-' klinkt als 'sk' in het Engels). Deze woorden moet je uit je hoofd leren — er is geen Nederlandse spellingregel die je kunt toepassen.",
        "solutionSteps": ["desain → design (onthoud: -sign)", "highlite → highlight (onthoud: -ight)", "laibel → label (onthoud: Engelse 'a' = 'ei'-klank)", "skedsjoel → schedule (onthoud: Engelse 'sch' = 'sk'-klank)"],
        "distractorExplanations": {}
      }
    }
  ]
}